const defaultProps = () => ({ style: { textAlign: 'right', minWidth: 60 } });

export const FALLOFFS_BY_WEEK_COLUMNS = [
  {
    name: 'transactionName',
    label: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'company',
    label: 'Company / Recruiter',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'industry',
    label: 'Industry',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'transactionName',
    label: 'Transaction / Status',
    options: {
      display: true
    }
  },
  {
    name: 'weekOfMonth-1',
    label: '1',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-2',
    label: '2',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-3',
    label: '3',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-4',
    label: '4',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  },
  {
    name: 'weekOfMonth-5',
    label: '5',
    options: {
      display: true,
      sort: false,
      renderer: 'currency',
      setCellProps: defaultProps,
      setCellHeaderProps: defaultProps
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'transactionName',
  direction: 'asc'
};
